/* global Calendly */
import parseObject from "utils/parsers/parseObject.js"

const CALENDLY_URL = "https://calendly.com/jake-santerre-buttercms/30min"
const { SHOW_CALENDLY } = parseObject({ id: "SALES_DATA" })

// Display the Calendly popup after a successful form submission
export default function useCalendly () {
    function getValue ( fieldName ) {
        const item = document.querySelector( `input[name=${ fieldName }]` )

        return item ? item.value : ""
    }

    function initCalendly () {
        const email = getValue( "work_email" )
        const firstName = getValue( "first_name" )
        const lastName = getValue( "last_name" )

        const preLoader = document.querySelector( ".pre-calendly-loader" )
        preLoader && preLoader.remove()

        Calendly.initPopupWidget({
            prefill: {
                email,
                name: `${ firstName } ${ lastName }`,
            },
            url: CALENDLY_URL,
        })
    }

    SHOW_CALENDLY && initCalendly()
}
